<template>
    <div class="buttons-connect" :class="{'column' : column || isMobile, 'background': backgroundBlack}">
        <RenaultButton  is-transparent :text="$t('button-connexion.particulier')" is-anchor :href="'/idconnect/country' + params"/>
        <RenaultButton  is-black :text="$t('button-connexion.profesionnel')" is-anchor :href="'/login' + params"/>
    </div>
</template>

<script>
import RenaultButton from '../Shared/RenaultButton.vue';
    export default {
        components: {
            RenaultButton,
        },

        props: {
            column: {
                type: Boolean,
                default: false
            },
            backgroundBlack: {
                type: Boolean,
                default: false
            },
            params: {
                type:String, 
                default: ''
            }
        },
        computed: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },
        },
    }
</script>